module.exports = __webpack_public_path__ + "static/media/simcase_csv_template.1edb7d24.csv";